import { httpService } from "utils";
import { DateObject } from "utils/DateObject";

import { useReactQuery } from "components/RemoteData";

import { IAppointmentDetailsDto } from "../application/types/IAppointmentDetailsDto";
import { IAppointmentDetails } from "../application/types/IAppointmentDetails";
import { useGetAuthorizationStore } from "../../authentication/infrastructure/useGetAuthorizationStore";

export const useGetUserAppointment = (appointmentId: string) => {
  const { userId } = useGetAuthorizationStore((state) => ({
    userId: state.userId,
  }));

  if (!userId) {
    throw new Error("UserId not found");
  }

  return useReactQuery(getUserAppointmentKey(userId, appointmentId), () =>
    getUserAppointment(userId, appointmentId)
  );
};

export const getUserAppointment = (
  userId: string,
  appointmentId: string
): Promise<IAppointmentDetails> => {
  return httpService()
    .get<IAppointmentDetailsDto>(
      `/e-reservation/user/${userId}/appointment/${appointmentId}/details`
    )
    .then((appointment) => {
      return {
        ...appointment,
        createDate: DateObject(appointment.createDate),
        startDate: DateObject(appointment.startDate),
        endDate: DateObject(appointment.endDate),
      };
    });
};

export const getUserAppointmentKey = (
  userId: string,
  appointmentId: string
) => {
  return `user-appointment-${userId}-${appointmentId}`;
};
